import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataService, DwOrmDataServiceToken, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, AppMetaDataLookups, DwUserEntity, FlightSchoolOrganizationEntity } from '../../../meta-data/app-meta-data.service';
import { Inject, Injectable } from '@angular/core';

@DwCustomContextDefinition({
    keyName: 'schoolProgramTypesContext',
    display: 'School Program Types',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.DwUser,
})
@DwCustomContextDefinition({
    keyName: 'schoolProgramTypesContext2',
    display: 'School Program Types 2',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolOrganization,
})
@Injectable()
export class SchoolProgramTypesContextService extends DwCustomContextBase {

    constructor(
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService
    ){
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const rootData = resolvedContext?.data as DwUserEntity | FlightSchoolOrganizationEntity;

            if (!rootData) {
                return { FlightSchoolProgramTypes : [] };
            }
            
            let flightSchoolOrganization : FlightSchoolOrganizationEntity; // = rootData?.FlightSchoolUser?.FlightSchoolOrganization;
            if (rootData._itemName == AppMetaDataItemNames.FlightSchoolOrganization) {
                flightSchoolOrganization = rootData as FlightSchoolOrganizationEntity;
            } else {
                flightSchoolOrganization = (rootData as DwUserEntity)?.FlightSchoolUser?.FlightSchoolOrganization;
            }

            const programTypes = flightSchoolOrganization?.FlightSchoolTrainingProgram?.filter(pt => !pt._isDeleted).map(pt => pt.AviationTrainingProgramId) || [];

            return { 
                FlightSchoolProgramTypes : programTypes
            };
        });

        contextDef.attributes = [];
        var attr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
                                                                        'FlightSchoolProgramTypes', 'Program Types', 
                                                                         DwAttributeType.Integer, DwControlType.DropDownList);
        
        attr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        attr.Attribute.IsLookup = true;
        attr.Attribute.MetaDataLookupId = AppMetaDataLookups.AviationTrainingProgramAllItems;
    }

}
